module.exports = __webpack_public_path__ + "images/5bf5566db02839c30274e6a5d906303f-IMG_5098.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/living/IMG_5098.jpg
// module id = ./src/assets/images/slides/living/IMG_5098.jpg
// module chunks = 0